import dispatchEvent from "../app/util/dispatchEvent";
import {CART_UPDATED, OPEN_CART} from "../app/util/events";
const axios = require('axios');

export default () => {
    const radioButtons = document.querySelectorAll('input[name="ShippingOption"]');
    if (radioButtons.length) {
        for (const radioButton of radioButtons) {
            radioButton.addEventListener('change', () => {
                const endpoint = 'cart-api/update-shipping';
                const formData = new FormData();
                formData.set('quote', radioButton.value);
                axios.post(endpoint, formData, {
                    headers: {
                        'x-requested-with': 'XMLHttpRequest'
                    }
                }).then((response) => {
                    dispatchEvent(CART_UPDATED, response.data);
                });
            });
        }
    }
}
